(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-live-info/assets/javascripts/casino-game-bottom-information.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-live-info/assets/javascripts/casino-game-bottom-information.js');

'use strict';

const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  format: {
    Currency: formatCurrency
  }
} = svs.utils;
const {
  ReactIcon: Icon
} = svs.ui;
const {
  isLiveTableClosed,
  getSeatsLeft,
  hasSeatsLeft
} = svs.components.casino_react.common.utils;
const LiveInfoLimits = _ref => {
  var _liveData$betLimits;
  let {
    liveCategory,
    liveData,
    closed
  } = _ref;
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  if (!(liveData !== null && liveData !== void 0 && (_liveData$betLimits = liveData.betLimits) !== null && _liveData$betLimits !== void 0 && (_liveData$betLimits = _liveData$betLimits[0]) !== null && _liveData$betLimits !== void 0 && _liveData$betLimits.min)) {
    return React.createElement("span", null, "\xA0");
  }
  if (isMobile && (closed || liveCategory === 'blackjack')) {
    return React.createElement("span", null, "> ".concat(formatCurrency(liveData.betLimits[0].min), " kr"));
  }
  return React.createElement("span", null, "".concat(formatCurrency(liveData.betLimits[0].min), " - ").concat(formatCurrency(liveData.betLimits[0].max), " kr"));
};
const LiveInfoWrapper = _ref2 => {
  let {
    children,
    title,
    liveData,
    closed,
    liveCategory
  } = _ref2;
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  return React.createElement("div", {
    className: "casino-game-card-live-info"
  }, React.createElement("h3", {
    className: "casino-game-card-live-info__title"
  }, title), React.createElement("div", {
    className: "casino-game-card-live-info__wrapper ".concat(isMobile ? 'f-200' : 'f-500 f-bold')
  }, children, React.createElement("p", {
    className: "casino-game-card-live-info__wrapper-window casino-game-card-live-info__wrapper-limits"
  }, React.createElement(LiveInfoLimits, {
    closed: closed,
    liveCategory: liveCategory,
    liveData: liveData
  }))));
};
const CasinoGameBottomInformation = _ref3 => {
  let {
    gameModel,
    liveData
  } = _ref3;
  if (!gameModel || (gameModel === null || gameModel === void 0 ? void 0 : gameModel.lobbyType) !== 'live') {
    return null;
  }
  const isClosed = isLiveTableClosed(liveData);
  if (isClosed) {
    var _liveData$openHours;
    return React.createElement(LiveInfoWrapper, {
      closed: true,
      liveCategory: gameModel.liveCategory,
      liveData: liveData,
      title: gameModel.title
    }, liveData !== null && liveData !== void 0 && (_liveData$openHours = liveData.openHours) !== null && _liveData$openHours !== void 0 && _liveData$openHours.startTime ? React.createElement("div", {
      className: "casino-game-card-live-info__wrapper-window casino-game-card-live-info__wrapper-hours"
    }, React.createElement(Icon, {
      color: "fc-white",
      icon: "clock",
      size: 100
    }), ' ', "Kl.", ' ', liveData.openHours.startTime) : React.createElement("p", {
      className: "casino-game-card-live-info__wrapper-window casino-game-card-live-info__wrapper-hours"
    }, "ST\xC4NGT"));
  }
  if (gameModel.name === 'infinite-blackjack' && liveData !== null && liveData !== void 0 && liveData.betBehind) {
    return React.createElement(LiveInfoWrapper, {
      liveCategory: gameModel.liveCategory,
      liveData: liveData,
      title: gameModel.title
    }, React.createElement("div", {
      className: "casino-game-card-live-info__wrapper-window casino-game-card-live-info__wrapper-hours"
    }, "Bet Behind"));
  }
  if (gameModel.liveCategory === 'blackjack' || gameModel.liveCategory === 'bjl') {
    if (hasSeatsLeft({
      provider: gameModel.provider,
      liveData
    })) {
      return React.createElement(LiveInfoWrapper, {
        liveCategory: gameModel.liveCategory,
        liveData: liveData,
        title: gameModel.title
      }, React.createElement("div", {
        className: "casino-game-card-live-info__wrapper-window casino-game-card-live-info__wrapper-hours"
      }, getSeatsLeft({
        provider: gameModel.provider,
        liveData
      }), ' ', "Lediga"));
    }
    if (liveData !== null && liveData !== void 0 && liveData.betBehind) {
      return React.createElement(LiveInfoWrapper, {
        liveCategory: gameModel.liveCategory,
        liveData: liveData,
        title: gameModel.title
      }, React.createElement("div", {
        className: "casino-game-card-live-info__wrapper-window casino-game-card-live-info__wrapper-hours"
      }, "Bet Behind"));
    }
  }
  return React.createElement(LiveInfoWrapper, {
    liveCategory: gameModel.liveCategory,
    liveData: liveData,
    title: gameModel.title
  });
};
setGlobal('svs.components.casino_react.casino_game_live_info.CasinoGameBottomInformation', CasinoGameBottomInformation);

 })(window);